<template>
  <div class="quickstart ma-auto text-center">
    <div class="subtitle">
      {{$t('settings.welcome.subtitle')}}
    </div>
    <player class="mt-4" videoId='Ax2BJvxnBr8'></player>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import player from '@/components/base/player';

export default {
  name: 'magicLink',

  components: {
    player,
  },

  computed: {
    ...mapGetters({
      courses: 'user/courses',
    }),
  },

  created () {
    if (!this.courses.length) {
      this.$router.replace(this.$i18nRoute({ name: 'subscriptionManagement' }));
    }
  },

};
</script>

<style lang="scss" scoped>
.subtitle {
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin: auto;
  text-align: center;
  color: #44445E;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
